module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"apply":"Candidate-se","login":"Entrar","enter":"Entrar"},"en":{"apply":"Apply","login":"Login","enter":"Enter"}}')
  delete Component.options._Ctor
}
